import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, getProduct, ShoppingBagComponent, InteriorComponent, HideFromAssemblyInstructionsComponent, OuterMeasurementsComponent, TopPanelComponent, FrontLayoutComponent, MultiHandleComponent, OrganizerComponent, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import LoftBedComponent from '../components/LoftBedComponent';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
import NonDuplicatableComponent from '@inter-ikea-storageone/range/src/core-api/components/NonDuplicatableComponent';
export const smastadComponentResolver = (_coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.SMASTAD_FRAME,
        ProductType.SMASTAD_PULL_OUT_FRAME_108_ASM,
        ProductType.SMASTAD_PULL_OUT_FRAME_196_ASM,
        ProductType.SMASTAD_SHELF,
        ProductType.SMASTAD_WIRE_BASKET_RAIL,
        ProductType.SMASTAD_WIRE_BASKET,
        ProductType.SMASTAD_LEG,
        ProductType.SMASTAD_SUSPENSION_RAIL,
        ProductType.SMASTAD_TOP,
        ProductType.SMASTAD_HINGE,
        ProductType.SMASTAD_DOOR_FRONT,
        ProductType.SMASTAD_CLOTH_RAIL_40,
        ProductType.SMASTAD_CLOTH_RAIL_55_RAIL,
        ProductType.SMASTAD_DRAWER_INSERT,
        ProductType.SMASTAD_DRAWER_FRONT,
        ProductType.SMASTAD_HOOK,
        ProductType.SMASTAD_RAIL_STRIP,
        ProductType.SMASTAD_BENCH,
        ProductType.SMASTAD_BENCH_DRAWER,
        ProductType.SMASTAD_DESK,
        ProductType.SMASTAD_CHANGING_TABLE,
        ProductType.SMASTAD_BENCH_PAD,
        ProductType.SMASTAD_BOX,
        ProductType.SMASTAD_HANGING_STORAGE_CASE,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.SMASTAD_FRAME_NA,
        ProductType.SMASTAD_FRAME_DRAWER_NA,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_LABEL_HOLDER,
        ProductType.SMASTAD_LOFT_BED
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.SMASTAD_FRAME,
        ProductType.SMASTAD_PULL_OUT_FRAME_108_ASM,
        ProductType.SMASTAD_PULL_OUT_FRAME_196_ASM,
        ProductType.SMASTAD_SHELF,
        ProductType.SMASTAD_WIRE_BASKET_ASM,
        ProductType.SMASTAD_LEG,
        ProductType.SMASTAD_TOP,
        ProductType.SMASTAD_HINGE_DOOR_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_40,
        ProductType.SMASTAD_CLOTH_RAIL_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM,
        ProductType.SMASTAD_INTERIOR_SUGGESTION,
        ProductType.SMASTAD_FRONT_LAYOUT,
        ProductType.SMASTAD_DRAWER_ASM,
        ProductType.SMASTAD_HOOK,
        ProductType.SMASTAD_RAIL_STRIP_W_HOOKS_ASM,
        ProductType.SMASTAD_BENCH,
        ProductType.SMASTAD_BENCH_DRAWER,
        ProductType.SMASTAD_BENCH_PAD,
        ProductType.SMASTAD_BOX,
        ProductType.SMASTAD_HANGING_STORAGE_CASE,
        ProductType.HANDLE,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.SMASTAD_FRAME_NA_ASM,
        ProductType.SMASTAD_FRAME_DRAWER_NA,
        ProductType.SMASTAD_FRAME_NA,
        ProductType.SMASTAD_CHANGING_TABLE,
        ProductType.SMASTAD_DESK,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_LABEL_HOLDER,
        ProductType.SMASTAD_LOFT_BED
    ]);
    const shouldHaveAssemblyInstructions = isOfType([
        ProductType.SMASTAD_FRAME,
        ProductType.SMASTAD_PULL_OUT_FRAME_108_ASM,
        ProductType.SMASTAD_PULL_OUT_FRAME_196_ASM,
        ProductType.SMASTAD_DESK,
        ProductType.SMASTAD_CHANGING_TABLE,
        ProductType.SMASTAD_FRAME_NA,
        ProductType.SMASTAD_LOFT_BED
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.SMASTAD_FRAME,
        ProductType.SMASTAD_PULL_OUT_FRAME_108,
        ProductType.SMASTAD_PULL_OUT_FRAME_196,
        ProductType.SMASTAD_LEG,
        ProductType.SMASTAD_TOP,
        ProductType.SMASTAD_BENCH,
        ProductType.SMASTAD_BENCH_DRAWER,
        ProductType.SMASTAD_DESK,
        ProductType.SMASTAD_CHANGING_TABLE,
        ProductType.SMASTAD_FRAME_NA,
        ProductType.SMASTAD_LOFT_BED,
        ProductType.SMASTAD_DOOR_FRONT,
        ProductType.SMASTAD_DRAWER_FRONT
    ]);
    const shouldBeIncludedInInnerMeasurement = isOfType([
        ProductType.SMASTAD_SHELF,
        ProductType.SMASTAD_WIRE_BASKET_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_40,
        ProductType.SMASTAD_CLOTH_RAIL_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM
    ]);
    const isInterior = isOfType([
        ProductType.SMASTAD_SHELF,
        ProductType.SMASTAD_WIRE_BASKET_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_40,
        ProductType.SMASTAD_CLOTH_RAIL_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM,
        ProductType.SMASTAD_RAIL_STRIP_W_HOOKS_ASM,
        ProductType.SMASTAD_DRAWER_ASM
    ]);
    const shouldBeRemovedFromAssemblyImages = isOfType([
        ProductType.SMASTAD_HINGE_DOOR_ASM,
        ProductType.SMASTAD_DRAWER_FRONT,
        ProductType.SMASTAD_DOOR_FRONT,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_LABEL_HOLDER,
        ProductType.SMASTAD_BOX
    ]);
    const isTopPanel = isOfType([ProductType.SMASTAD_TOP]);
    const isHingedDoor = isOfType([ProductType.SMASTAD_HINGE_DOOR_ASM]);
    const isDrawer = isOfType([ProductType.SMASTAD_DRAWER_ASM, ProductType.SMASTAD_BENCH_DRAWER]);
    const isOrganizer = isOfType([
        ProductType.SMASTAD_BOX,
        ProductType.SMASTAD_HANGING_STORAGE_CASE,
        ProductType.SMASTAD_LABEL_HOLDER,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_HOOK,
        ProductType.SMASTAD_HOOK_CLIP
    ]);
    const shouldNotBeDraggable = (entity) => {
        return isHingedDoor(entity) || isTopPanel(entity) || isDrawer(entity);
    };
    const isNonDuplicatable = isOfType([ProductType.SMASTAD_LEG]);
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (product?.meta?.defaultFrontLayout) {
                entity.addComponent(new FrontLayoutComponent(product.meta?.defaultFrontLayout));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
            if (shouldBeIncludedInInnerMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
            }
            if (shouldNotBeDraggable(entity)) {
                entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
            }
            if (isTopPanel(entity)) {
                entity.addComponent(new TopPanelComponent());
            }
            if (isOrganizer(entity)) {
                entity.addComponent(new OrganizerComponent());
            }
            if (product?.meta?.nbrOfHandles) {
                entity.addComponent(new MultiHandleComponent(product.meta.nbrOfHandles));
            }
            if (product?.meta?.loftBedOrientation) {
                entity.addComponent(new LoftBedComponent(product.meta.loftBedOrientation.mirrored, product.meta.loftBedOrientation['inward-desk'], product.meta.loftBedOrientation['inward-cabinet']));
            }
            if (isNonDuplicatable(entity)) {
                entity.addComponent(new NonDuplicatableComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=smastadComponentResolver.js.map